type PagesList = {
  key: number;
  title: string;
};

export const pagesList: PagesList[] = [
  {
    key: 1,
    title: 'Справочники/Реестры',
  },
];
